(function () {
  var STORAGE_KEY = 'sms-wishlist-v1';

  function loadWishlist() {
    try {
      var raw = window.localStorage.getItem(STORAGE_KEY);
      if (!raw) return [];
      var parsed = JSON.parse(raw);
      if (!Array.isArray(parsed)) return [];
      return parsed;
    } catch (e) {
      return [];
    }
  }

  function saveWishlist(items) {
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
    } catch (e) {
      // ignore
    }
  }

  function findIndex(items, variantId) {
    return items.findIndex(function (it) {
      return String(it.variantId) === String(variantId);
    });
  }

  // cache of /products/{handle}.js
  var productCache = {};

  function fetchProductByHandle(handle) {
    if (!handle) return Promise.resolve(null);
    if (productCache[handle]) return productCache[handle];

    productCache[handle] = fetch('/products/' + encodeURIComponent(handle) + '.js', {
      credentials: 'same-origin'
    })
      .then(function (r) {
        if (!r.ok) throw new Error('Bad product response');
        return r.json();
      })
      .catch(function () {
        return null;
      });

    return productCache[handle];
  }

  function formatMoney(cents) {
    if (window.Shopify && typeof Shopify.formatMoney === 'function') {
      return Shopify.formatMoney(cents);
    }
    var num = (cents / 100).toFixed(2);
    return '$' + num;
  }

  function variantPriceCents(variant) {
    if (!variant) return null;
    if (typeof variant.price === 'number') return variant.price;
    var n = parseFloat(variant.price);
    if (!isFinite(n)) return null;
    return Math.round(n * 100);
  }

  function firstAvailableVariant(product) {
    if (!product || !Array.isArray(product.variants) || !product.variants.length) return null;
    return product.variants.find(function (v) { return v.available; }) || product.variants[0];
  }

 // Build a share URL that opens the full wishlist page
function getShareUrl(items) {
  // ✅ your actual wishlist page:
  var wishlistPath = '/pages/wish-list';

  // Build URL pointing at the wishlist page
  var url = new URL(wishlistPath, window.location.origin);

  // If no items, just link to the empty wishlist page
  if (!items.length) {
    return url.toString();
  }

  // Compact format: handle:variantId:qty;handle:variantId:qty;...
  var compact = items.map(function (it) {
    var handle = (it.handle || '').trim();
    // safety: remove delimiters if somehow present
    handle = handle.replace(/[:;]/g, '-');

    var variantId = String(it.variantId || '').trim();
    var qty = parseInt(it.quantity || 1, 10);
    if (!qty || qty < 1) qty = 1;

    return handle + ':' + variantId + ':' + qty;
  }).join(';');

  url.searchParams.set('wl', compact);
  return url.toString();
}



  function Wishlist() {
    this.items = loadWishlist();
    this.drawerEl = document.querySelector('[data-wishlist-drawer]');
    this.listEl = this.drawerEl && this.drawerEl.querySelector('[data-wishlist-list]');
    this.emptyEl = this.drawerEl && this.drawerEl.querySelector('[data-wishlist-empty]');
    this.addAllBtn = this.drawerEl && this.drawerEl.querySelector('[data-wishlist-add-all]');
    this.shareBtn = this.drawerEl && this.drawerEl.querySelector('[data-wishlist-share]');
    this.accountRoot = document.querySelector('[data-wishlist-account-root]');
    this.init();
  }

  Wishlist.prototype.init = function () {
    var self = this;

    // Buttons on product page
    document.querySelectorAll('[data-wishlist-toggle]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var payload = {
          productId: btn.getAttribute('data-product-id'),
          handle: btn.getAttribute('data-product-handle'),
          variantId: btn.getAttribute('data-variant-id'),
          title: btn.getAttribute('data-product-title'),
          url: btn.getAttribute('data-product-url'),
          image: btn.getAttribute('data-product-image')
        };
        self.toggleItem(payload);
      });
    });

    // Open/close drawer
    document.querySelectorAll('[data-wishlist-open]').forEach(function (btn) {
      btn.addEventListener('click', function () { self.openDrawer(); });
    });
    document.querySelectorAll('[data-wishlist-close]').forEach(function (btn) {
      btn.addEventListener('click', function () { self.closeDrawer(); });
    });
    document.addEventListener('keyup', function (event) {
      if (event.key === 'Escape') self.closeDrawer();
    });

    // Drawer footer buttons
    if (this.addAllBtn) {
      this.addAllBtn.addEventListener('click', function () {
        self.addAllToCart();
      });
    }
    if (this.shareBtn) {
      this.shareBtn.addEventListener('click', function () {
        self.shareWishlist();
      });
    }

    // Initial render
    this.renderAll();
  };

  Wishlist.prototype.toggleItem = function (item) {
    var idx = findIndex(this.items, item.variantId);
    if (idx === -1) {
      this.items.push(
        Object.assign(
          {
            quantity: 1,
            priceCents: null
          },
          item
        )
      );
    } else {
      this.items.splice(idx, 1);
    }
    saveWishlist(this.items);
    this.renderAll();
  };

  Wishlist.prototype.renderAll = function () {
    this.renderButtons();
    this.renderDrawer();
    this.renderAccount();
  };

  Wishlist.prototype.renderButtons = function () {
    var self = this;
    document.querySelectorAll('[data-wishlist-toggle]').forEach(function (btn) {
      var variantId = btn.getAttribute('data-variant-id');
      var idx = findIndex(self.items, variantId);
      var icon = btn.querySelector('.wishlist-toggle__icon');
      var text = btn.querySelector('.wishlist-toggle__text');

      if (idx === -1) {
        btn.classList.remove('is-active');
        if (icon) icon.textContent = '♡';
        if (text) text.textContent = 'Add to wishlist';
      } else {
        btn.classList.add('is-active');
        if (icon) icon.textContent = '❤';
        if (text) text.textContent = 'In wishlist';
      }
    });
  };

  Wishlist.prototype.updateTotal = function () {
    if (!this.drawerEl) return;
    var totalEl = this.drawerEl.querySelector('[data-wishlist-total]');
    if (!totalEl) return;

    var totalCents = 0;
    this.items.forEach(function (item) {
      var price = item.priceCents;
      var qty = item.quantity || 1;
      if (price != null && isFinite(price)) {
        totalCents += price * qty;
      }
    });

    var row = totalEl.parentElement;

    if (!this.items.length || totalCents <= 0) {
      totalEl.textContent = '';
      if (row) row.classList.add('wishlist-drawer__total--empty');
    } else {
      totalEl.textContent = 'Wishlist total: ' + formatMoney(totalCents);
      if (row) row.classList.remove('wishlist-drawer__total--empty');
    }
  };

  Wishlist.prototype.renderDrawer = function () {
    if (!this.drawerEl || !this.listEl || !this.emptyEl) return;
    var self = this;

    this.listEl.innerHTML = '';

    if (!this.items.length) {
      this.emptyEl.style.display = '';
      if (this.addAllBtn) this.addAllBtn.disabled = true;
      if (this.shareBtn) this.shareBtn.disabled = true;
      this.updateTotal();
      return;
    }

    this.emptyEl.style.display = 'none';
    if (this.addAllBtn) this.addAllBtn.disabled = false;
    if (this.shareBtn) this.shareBtn.disabled = false;

    this.items.forEach(function (item) {
      if (!item.quantity || item.quantity < 1) item.quantity = 1;

      var li = document.createElement('li');
      li.className = 'wishlist-item';
      li.setAttribute('data-variant-id', item.variantId);
      li.setAttribute('data-product-handle', item.handle || '');

      // IMAGE
      var imgWrap = document.createElement('div');
      imgWrap.className = 'wishlist-item__image-wrapper';
      if (item.image) {
        var img = document.createElement('img');
        img.className = 'wishlist-item__image';
        img.loading = 'lazy';
        img.alt = item.title || '';
        img.src = item.image;
        imgWrap.appendChild(img);
      }
      li.appendChild(imgWrap);

      // MAIN CONTENT
      var main = document.createElement('div');
      main.className = 'wishlist-item__main';

      var link = document.createElement('a');
      link.className = 'wishlist-item__link';
      link.href = item.url || '#';

      var titleEl = document.createElement('p');
      titleEl.className = 'wishlist-item__title';
      titleEl.textContent = item.title || 'Product';

      link.appendChild(titleEl);
      main.appendChild(link);

      // price text
      var priceEl = document.createElement('p');
      priceEl.className = 'wishlist-item__price';
      main.appendChild(priceEl);

      // Controls wrapper
      var controls = document.createElement('div');
      controls.className = 'wishlist-item__controls';

      // Variant label + select
      var variantLabel = document.createElement('label');
      variantLabel.className = 'wishlist-item__field';
      var variantText = document.createElement('span');
      variantText.className = 'wishlist-item__variant-label';
      variantText.textContent = 'Variant';
      var variantSelect = document.createElement('select');
      variantSelect.className = 'wishlist-item__variant-select';
      variantSelect.disabled = true;
      variantSelect.innerHTML = '<option>Loading…</option>';
      variantLabel.appendChild(variantText);
      variantLabel.appendChild(variantSelect);
      controls.appendChild(variantLabel);

      // Quantity input
      var qtyLabel = document.createElement('label');
      qtyLabel.className = 'wishlist-item__field';
      var qtyText = document.createElement('span');
      qtyText.textContent = 'Qty';
      var qtyInput = document.createElement('input');
      qtyInput.type = 'number';
      qtyInput.min = '1';
      qtyInput.value = String(item.quantity);
      qtyInput.className = 'wishlist-item__qty';
      qtyLabel.appendChild(qtyText);
      qtyLabel.appendChild(qtyInput);
      controls.appendChild(qtyLabel);

      main.appendChild(controls);

      // Remove button
      var removeBtn = document.createElement('button');
      removeBtn.type = 'button';
      removeBtn.className = 'wishlist-item__remove';
      removeBtn.setAttribute('data-wishlist-remove', item.variantId);
      removeBtn.textContent = 'Remove';
      main.appendChild(removeBtn);

      li.appendChild(main);

      self.listEl.appendChild(li);

      // quantity change handler
      qtyInput.addEventListener('change', function () {
        var v = parseInt(qtyInput.value, 10);
        if (!isFinite(v) || v < 1) v = 1;
        qtyInput.value = String(v);
        item.quantity = v;
        saveWishlist(self.items);
        self.updateTotal();
      });

      // remove handler
      removeBtn.addEventListener('click', function () {
        var idx = findIndex(self.items, item.variantId);
        if (idx !== -1) {
          self.items.splice(idx, 1);
          saveWishlist(self.items);
          self.renderAll();
        }
      });

      // load product JSON for variant list + price + variant label
      fetchProductByHandle(item.handle).then(function (product) {
        if (!product) {
          variantSelect.innerHTML = '<option>Variant unavailable</option>';
          variantSelect.disabled = true;
          self.updateTotal();
          return;
        }

        variantSelect.innerHTML = '';
        product.variants.forEach(function (v) {
          var opt = document.createElement('option');
          opt.value = String(v.id);
          var label = v.public_title || v.title || '';
          if (!label || /default/i.test(label)) label = 'Default';
          var cents = variantPriceCents(v);
          if (cents != null) {
            label += ' – ' + formatMoney(cents);
          }
          opt.textContent = label;
          opt.disabled = !v.available;
          if (String(v.id) === String(item.variantId)) {
            opt.selected = true;
          }
          variantSelect.appendChild(opt);
        });

        if (!variantSelect.value && product.variants.length) {
          var fv = firstAvailableVariant(product) || product.variants[0];
          variantSelect.value = String(fv.id);
          item.variantId = String(fv.id);
        }

        var currentVariant = product.variants.find(function (v) {
          return String(v.id) === String(variantSelect.value);
        }) || firstAvailableVariant(product);

        if (currentVariant) {
          var labelText = currentVariant.public_title || currentVariant.title || '';
          if (!labelText || /default/i.test(labelText)) {
            labelText = 'Selected variant';
          }
          variantText.textContent = labelText;

          var centsInit = variantPriceCents(currentVariant);
          if (centsInit != null) {
            item.priceCents = centsInit;
            priceEl.textContent = formatMoney(centsInit);
          }
        }

        saveWishlist(self.items);
        self.updateTotal();

        variantSelect.disabled = false;

        // When variant changes
        variantSelect.addEventListener('change', function () {
          var vid = variantSelect.value;
          item.variantId = vid;

          var v = product.variants.find(function (x) {
            return String(x.id) === String(vid);
          });
          if (v) {
            var c = variantPriceCents(v);
            if (c != null) {
              item.priceCents = c;
              priceEl.textContent = formatMoney(c);
            }

            var newLabel = v.public_title || v.title || '';
            if (!newLabel || /default/i.test(newLabel)) {
              newLabel = 'Selected variant';
            }
            variantText.textContent = newLabel;
          }

          saveWishlist(self.items);
          self.updateTotal();
          self.renderButtons();
        });
      });
    });

    // make sure total is at least cleared/updated
    this.updateTotal();
  };

  Wishlist.prototype.renderAccount = function () {
    if (!this.accountRoot) return;
    var root = this.accountRoot;
    root.innerHTML = '';

    var title = document.createElement('h2');
    title.textContent = 'Your wishlist';
    root.appendChild(title);

    if (!this.items.length) {
      var p = document.createElement('p');
      p.textContent = 'You don’t have anything in your wishlist on this device yet.';
      root.appendChild(p);
      return;
    }

    var ul = document.createElement('ul');
    ul.className = 'wishlist-drawer__list';
    this.items.forEach(function (item) {
      var li = document.createElement('li');
      li.className = 'wishlist-item';
      li.innerHTML =
        '<div class="wishlist-item__image-wrapper">' +
          (item.image
            ? '<img class="wishlist-item__image" loading="lazy" alt="' + (item.title || '') + '" src="' + item.image + '">'
            : '') +
        '</div>' +
        '<div class="wishlist-item__main">' +
          '<a class="wishlist-item__link" href="' + (item.url || '#') + '">' +
            '<p class="wishlist-item__title">' + (item.title || 'Product') + '</p>' +
          '</a>' +
          '<p class="wishlist-item__meta">Qty: ' + (item.quantity || 1) + '</p>' +
        '</div>';
      ul.appendChild(li);
    });

    root.appendChild(ul);
  };

  Wishlist.prototype.openDrawer = function () {
    if (!this.drawerEl) return;
    this.drawerEl.classList.add('is-open');
    document.documentElement.classList.add('wishlist-no-scroll');
  };

  Wishlist.prototype.closeDrawer = function () {
    if (!this.drawerEl) return;
    this.drawerEl.classList.remove('is-open');
    document.documentElement.classList.remove('wishlist-no-scroll');
  };

  Wishlist.prototype.addAllToCart = function () {
    if (!this.items.length) return;

    var payload = {
      items: this.items.map(function (item) {
        var qty = item.quantity && item.quantity > 0 ? item.quantity : 1;
        return {
          id: item.variantId,
          quantity: qty
        };
      })
    };

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify(payload)
    })
      .then(function () {
        document.dispatchEvent(new CustomEvent('cart:refresh'));
      })
      .catch(function () {
        // ignore
      });
  };

  Wishlist.prototype.shareWishlist = function () {
    var url = getShareUrl(this.items);
    if (!url) return;

    if (navigator.share) {
      navigator.share({
        title: 'My wishlist',
        url: url
      }).catch(function () { /* ignore */ });
      return;
    }

    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(url).then(function () {
        alert('Wishlist link copied to clipboard.');
      }).catch(function () {
        window.prompt('Copy this wishlist link:', url);
      });
    } else {
      window.prompt('Copy this wishlist link:', url);
    }
  };

  document.addEventListener('DOMContentLoaded', function () {
    new Wishlist();
  });
})();
